type BrandIconProps = {
  size?: number;
};

/** DouBoard's bold marker-loop monogram, shared by the site and social previews. */
export function BrandIcon({ size = 40 }: BrandIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect width="64" height="64" rx="18" fill="#E61E73" />
      <path
        d="M20 46V18H31C43 18 49 24 49 32S43 46 31 46H20"
        stroke="#FFFFFF"
        strokeWidth="6.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.5 50L23 43.5" stroke="#FFE58F" strokeWidth="4" strokeLinecap="round" />
      <circle cx="49" cy="14" r="4" fill="#FFE58F" />
    </svg>
  );
}
